import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = ["hiddenField"];

  connect() {
    this.hiddenFieldValue = this._initHiddenFieldValue();
    this._initAttendanceCells();
  }

  handleClick(event) {
    event.preventDefault();
    const cell = event.currentTarget;
    const shapeElement = cell.firstElementChild;
    if (shapeElement.classList.contains("attendance-1")) {
      shapeElement.classList.toggle("attendance-1");
      shapeElement.classList.toggle("attendance-2");
      cell.dataset.value = "2";
    } else if (shapeElement.classList.contains("attendance-2")) {
      shapeElement.classList.toggle("attendance-2");
      shapeElement.classList.toggle("attendance-3");
      cell.dataset.value = "3";
    } else if (shapeElement.classList.contains("attendance-3")) {
      shapeElement.classList.toggle("attendance-3");
      shapeElement.classList.toggle("attendance-4");
      shapeElement.innerHTML = "R";
      cell.dataset.value = "4";
    } else if (shapeElement.classList.contains("attendance-4")) {
      shapeElement.classList.toggle("attendance-4");
      shapeElement.innerHTML = "";
      cell.dataset.value = "0";
    } else {
      shapeElement.classList.toggle("attendance-1");
      cell.dataset.value = "1";
    }
    this._updateHiddenFieldValue(cell.dataset.timeRange, cell.dataset.weekDay, cell.dataset.value);
  }

  _initAttendanceCells() {
    if (Object.keys(this.hiddenFieldValue).length != 0) {
      const timeRangesArray = JSON.parse(this.hiddenFieldTarget.dataset.timeRanges);
      timeRangesArray.forEach((range) => {
        if (this.hiddenFieldValue[range]) {
          for (const [weekday, value] of Object.entries(this.hiddenFieldValue[range])) {
            if (value != 0) {
              this._initAttendanceCell(range, weekday, value);
            }
          }
        }
      });
    }
  }

  _initAttendanceCell(range, weekday, value) {
    const cellToModify = document.getElementById(`${weekday}-${range}`);
    cellToModify.firstElementChild.classList.add(`attendance-${value}`);
    if (Number(value) === 4) {
      cellToModify.firstElementChild.innerHTML = "R";
    }
  }

  _initHiddenFieldValue() {
    if (!this.hiddenFieldTarget.value) {
      return {
        "7h00-7h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "7h30-8h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "8h00-8h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "8h30-9h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "9h00-9h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "9h30-10h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "10h00-10h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "10h30-11h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "11h00-11h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "11h30-12h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "12h00-12h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "12h30-13h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "13h00-13h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "13h30-14h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "14h00-14h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "14h30-15h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "15h00-15h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "15h30-16h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "16h00-16h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "16h30-17h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "17h00-17h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "17h30-18h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "18h00-18h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "18h30-19h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "19h00-19h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "19h30-20h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "20h00-20h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "20h30-21h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "21h00-21h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "21h30-22h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "22h00-22h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "22h30-23h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "23h00-23h30": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
        "23h30-24h00": {
          monday: "0",
          tuesday: "0",
          wednesday: "0",
          thursday: "0",
          friday: "0",
          saturday: "0",
          sunday: "0",
        },
      };
    }
    return JSON.parse(this.hiddenFieldTarget.value);
  }

  _updateHiddenFieldValue(timeRange, weekDay, value) {
    if (!Object.prototype.hasOwnProperty.call(this.hiddenFieldValue, timeRange)) {
      this.hiddenFieldValue[timeRange] = {};
    }
    this.hiddenFieldValue[timeRange][weekDay] = value;
    this.hiddenFieldTarget.value = JSON.stringify(this.hiddenFieldValue);
  }
}
